import React from 'react'

import { itemLabels } from '@srca-b2b/kp5-ui-common/lib/agreements'
import { useTranslation } from 'react-i18next'

/**
 * See logic in KP2 knox_registration_add_legal_form_elements.
 *
 * @param agreementsToAccept
 * @param showTerms
 * @returns {JSX.Element}
 * @constructor
 */
const GdprConsentElements = ({ agreementsToAccept, showTerms = true, formAgreements }) => {
  console.log('GdprConsentElements agreementsToAccept:', agreementsToAccept)
  const { t } = useTranslation('common')

  const legalCompliantLabels = (legalLabels) => {
    let agreementsList = legalLabels.filter((legalType) => !formAgreements?.includes(legalType))
    agreementsList = agreementsList
      .map((label) => (
        <a
          key={`${label}-href-link`}
          href={itemLabels[label].externalHref}
          target={'_blank'}
          rel="noreferrer"
        >
          {itemLabels[label].modalLink}
        </a>
      ))
      .reduce((prev, curr, index, array) => {
        if (index == array.length - 1) {
          return [prev, ', and ', curr]
        }

        return [prev, ', ', curr]
      })

    return <>{agreementsList}</>
  }

  const renderLegalContents = (legalType) => {
    let legalContentsArr = []
    switch (legalType) {
      case 'registration_privacy_policy':
        legalContentsArr.push(
          <p className="lead">
            {t('To_continue_agree_to_the')}&nbsp;{legalCompliantLabels([...agreementsToAccept])}.
          </p>
        )
        break
      case 'privacy_policy_usa':
        legalContentsArr.push(
          <p className="lead">
            {t('To_continue_agree_to_the')}&nbsp;
            {legalCompliantLabels([
              'privacy_policy_usa',
              'registration_terms_use',
              'kcs_product_terms_conditions',
              'kcs_data_processing_agreement'
            ])}
            .
          </p>
        )
        break
      case 'privacy_consent_ko':
        legalContentsArr.push(
          <p className="lead">
            {t('To_continue_agree_to_the')}&nbsp;
            {legalCompliantLabels([
              'msp_terms_agreement',
              'privacy_policy_ko_scpe',
              'kg_terms_agreement',
              'registration_terms_use',
              'kcs_product_terms_conditions',
              'kcs_data_processing_agreement'
            ])}
            .
          </p>
        )
        break
      case 'privacy_policy_vn':
        legalContentsArr.push(
          <p className="lead">
            {t('To_continue_agree_to_the')}&nbsp;
            {legalCompliantLabels([
              'privacy_policy_vn',
              'registration_terms_use',
              'kcs_product_terms_conditions',
              'kcs_data_processing_agreement',
              ...(agreementsToAccept.includes('privacy_policy_vn_scpe')
                ? ['privacy_policy_vn_scpe']
                : [])
            ])}
            .
          </p>
        )
        break
      case 'privacy_policy_eu':
      case 'privacy_policy_br':
      case 'privacy_policy_tk':
        legalContentsArr.push(
          <>
            <p className="lead">
              {t('Check_our')}&nbsp;{legalCompliantLabels([legalType])}
              &nbsp;{t('to_see_how_we_manage_your_data')}
            </p>
            {showTerms && (
              <p className="lead">
                {t('By_continuing_text')}&nbsp;
                {legalCompliantLabels([
                  'registration_terms_use',
                  'kcs_product_terms_conditions',
                  'kcs_data_processing_agreement'
                ])}
                .
              </p>
            )}
          </>
        )
        break
      default:
        break
    }

    return legalContentsArr
  }

  return agreementsToAccept.map((legalType) => renderLegalContents(legalType))
}

export default GdprConsentElements
